import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

/**
 * Keeping strings together that have product names in them that will change.
 * Ex. "datasets".
 */
export function getProjectProgressTooltipMsg(
  numCompleted: number,
  numTotal: number
): MessageDescriptor {
  return msg({
    message: `${numCompleted} of ${numTotal} datasets completed`,
    context: `Tooltip showing dataset completion progress`,
  });
}
